export default __webpack_public_path__ + "static/media/help_support.87d7cd9f.svg";